import React, { useState, useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";
// reactstrap components
import {
  Form,
  FormGroup,
  Input,
  Row,
  Button,
  Container,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import ReactDatetime from "react-datetime";

import DefaultFooter from "../../Components/Footers/DefaultFooter";
import ScrollTransparentNavbar from "../../Components/Navbars/ScrollTransparentNavbar";

import * as actions from "../../store/actions/index";

const ManualCapture = (props) => {
  console.log("props", props.test);
  const [first1Focus, setFirst1Focus] = useState(false);
  const [last1Focus, setLast1Focus] = useState(false);
  const [eventTimeFocus, setEventTimeFocus] = useState(false);
  const [eventTime, setEventTime] = useState("");
  const [distanceFocus, setDistanceFocus] = useState(false);
  const [distance, setDistance] = useState("");
  const [alert, setAlert] = useState(null);

  const selectRunAlert = (message, show, eventTime, distance) => {
    setAlert(
      <SweetAlert
        warning
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="Submit this run?"
        onConfirm={() => success(eventTime, distance)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes"
        cancelBtnText="Cancel"
        show={show}
        showCancel
        reverseButtons
      >
        {message}
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const successHideAlert = () => {
    props.onCaptureEventFinish();
    props.history.push("/Profile");
  };

  const success = (eventTime, distance) => {
    console.log("eventTime", props.selectedEvent, eventTime, distance);
    props.onSaveCapturedEvent({
      item: {
        user: props.user,
        eventTime,
        distance,
        event: props.selectedEvent,
      },
    });
  };

  useEffect(() => {
    if (props.success) {
      setAlert(
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Run saved!"
          onConfirm={() => successHideAlert()}
          onCancel={() => successHideAlert()}
          confirmBtnBsStyle="info"
        >
          Your run has been successfully saved.
        </SweetAlert>
      );
    }
  }, [props]);

  return (
    <>
      <ScrollTransparentNavbar />
      <div className="cd-section" id="contact-us">
        <div
          className="contactus-1 section-image"
          style={{
            backgroundImage:
              "url(" +
              require("../../assets/img/pexels-photo-2526878.jpeg").default +
              ")",
          }}
        >
          <Container>
            {alert}
            <Row>
              <Col md="5">
                <h2 className="title">{props.selectedEvent.data.name}</h2>
                <h4 className="description">
                  Input your event time and add any feedback that you'd like.
                  Alternatively, you could connect to Strava and we'll
                  automatically get your run data.
                </h4>
                <div className="info info-horizontal">
                  <div className="icon icon-info">
                    <i className="now-ui-icons location_pin"></i>
                  </div>
                  <div className="description">
                    <h4 className="info-title">Where?</h4>
                    <p className="description">
                      Any area of your chosing, within COVID regulations.
                      <br />
                      Wear your mask
                    </p>
                  </div>
                </div>
                <div className="info info-horizontal">
                  <div className="icon icon-info">
                    <i className="now-ui-icons tech_mobile"></i>
                  </div>
                  <div className="description">
                    <h4 className="info-title">Contact us</h4>
                    <p className="description">
                      Elton Davids <br></br>
                      082 468 0081 <br></br>
                      <a href="mailto:office@allmysports-sa.com">
                        office@allmysports-sa.com
                      </a>
                    </p>
                  </div>
                </div>
              </Col>
              <Col className="ml-auto mr-auto" md="5">
                <Card className="card-contact card-raised">
                  <Form
                    id="manual-capture-form"
                    role="form"
                    onSubmit={(e) => {
                      e.preventDefault();
                      selectRunAlert(
                        props.selectedEvent.data.name,
                        true,
                        eventTime,
                        distance
                      );
                    }}
                  >
                    <CardHeader className="text-center">
                      <CardTitle tag="h4">Event Result</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col className="pr-2" md="6">
                          <label>First name</label>
                          <InputGroup
                            className={first1Focus ? "input-group-focus" : ""}
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="now-ui-icons users_circle-08"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              aria-label="First Name..."
                              autoComplete="given-name"
                              placeholder="First Name..."
                              disabled
                              type="text"
                              value={props.user.firstName}
                              onFocus={() => setFirst1Focus(true)}
                              onBlur={() => setFirst1Focus(false)}
                            ></Input>
                          </InputGroup>
                        </Col>
                        <Col className="pl-2" md="6">
                          <FormGroup>
                            <label>Last name</label>
                            <InputGroup
                              className={last1Focus ? "input-group-focus" : ""}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="now-ui-icons text_caps-small"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                aria-label="Last Name..."
                                autoComplete="family-name"
                                placeholder="Last Name..."
                                type="text"
                                disabled
                                onFocus={() => setLast1Focus(true)}
                                onBlur={() => setLast1Focus(false)}
                                value={props.user.lastName}
                              ></Input>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pr-2" md="6">
                          <FormGroup>
                            <label>Event time</label>
                            <InputGroup
                              className={
                                eventTimeFocus ? "input-group-focus" : ""
                              }
                            >
                              <ReactDatetime
                                inputProps={{
                                  className: "form-control",
                                  placeholder: "Date Picker Here",
                                  required: true,
                                }}
                                onChange={(date) => setEventTime(date)}
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat={false}
                                timeFormat="HH:mm:ss"
                                onFocus={() => setEventTimeFocus(true)}
                                onBlur={() => setEventTimeFocus(false)}
                              ></ReactDatetime>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col className="pl-2" md="6">
                          <FormGroup>
                            <label>Distance</label>
                            <InputGroup
                              className={
                                distanceFocus ? "input-group-focus" : ""
                              }
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="now-ui-icons location_compass-05"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                required
                                aria-label="Distance..."
                                placeholder="Distance..."
                                type="number"
                                onFocus={() => setDistanceFocus(true)}
                                onBlur={() => setDistanceFocus(false)}
                                onChange={(event) =>
                                  setDistance(event.target.value)
                                }
                              ></Input>{" "}
                              KM
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      <FormGroup>
                        <label>Your message</label>
                        <Input
                          id="message"
                          name="message"
                          placeholder="Feedback"
                          rows="6"
                          type="textarea"
                        ></Input>
                      </FormGroup>
                      <Row>
                        <Col md="6"></Col>
                        <Col md="6">
                          <Button
                            className="btn-round pull-right"
                            color="info"
                            type="submit"
                          >
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <DefaultFooter />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    selectedEvent: state.event.selectedEvent,
    user: state.authentication.user,
    success: state.capturedEvent.success,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetStravaAuthCode: (authCode, refresh_token, tokenExpired) =>
      dispatch(
        actions.getStravaAuthCode(authCode, refresh_token, tokenExpired)
      ),
    onGetStravaActivities: (access_token) =>
      dispatch(actions.getStravaActivities(access_token)),
    onGetStravaAthlete: (access_token) =>
      dispatch(actions.getStravaAthlete(access_token)),
    onSaveCapturedEvent: (capturedEvent) =>
      dispatch(actions.saveCapturedEvent(capturedEvent)),
    onCaptureEventFinish: () => dispatch(actions.captureEventFinish()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualCapture);
